import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getLastCitySlug } from "../utils/userPreferences";
import { DEFAULT_CITY_SLUG } from "../utils/aiAssistantTypes";

export function useAiCitySlug() {
  const location = useLocation();

  return useMemo(() => {
    const qs = new URLSearchParams(location.search);
    const fromUrl = qs.get("city");
    if (fromUrl && fromUrl.trim()) {
      return fromUrl.trim().toLowerCase();
    }
    return getLastCitySlug() || DEFAULT_CITY_SLUG;
  }, [location.search]);
}

export default useAiCitySlug;
